(function() {
  define('bazemont/newsletter/subscribers',['angular'], function() {
    'use strict';
    return angular.module('bazemontNewsletterSubscribers', []).component('bazemontNewsletterSubscribers', {
      templateUrl: '/assets/javascripts/bazemont/newsletter/subscribers.html',
      controller: [
        '$http', function($http) {
          var setNbVerifiedOptinSubscribers, vm;
          vm = this;
          vm.$onInit = function() {
            vm.initOrderBy = ['email'];
            vm.orderBy = vm.initOrderBy;
            vm.yesNoArray = [
              {
                label: '',
                value: void 0
              }, {
                label: 'Oui',
                value: true
              }, {
                label: 'Non',
                value: false
              }
            ];
            return $http.get('/api/admin/newsletter/subscribers').then(function(response) {
              vm.subscribers = response.data;
              return setNbVerifiedOptinSubscribers();
            });
          };
          setNbVerifiedOptinSubscribers = function() {
            var subscriber, _i, _len, _ref, _results;
            vm.nbVerifiedOptinSubscribers = 0;
            _ref = vm.subscribers;
            _results = [];
            for (_i = 0, _len = _ref.length; _i < _len; _i++) {
              subscriber = _ref[_i];
              if (subscriber.isVerified && subscriber.isOptin) {
                _results.push(vm.nbVerifiedOptinSubscribers++);
              } else {
                _results.push(void 0);
              }
            }
            return _results;
          };
          vm.showSubscriber = function(subscriber) {
            return (vm.filterVerified === void 0 || subscriber.isVerified === vm.filterVerified) && (vm.filterOptin === void 0 || subscriber.isOptin === vm.filterOptin);
          };
          vm["export"] = function($event) {
            var optin, verified;
            verified = vm.filterVerified === void 0 ? "undefined" : vm.filterVerified ? "yes" : "no";
            optin = vm.filterOptin === void 0 ? "undefined" : vm.filterOptin ? "yes" : "no";
            window.open('/admin/newsletter/inscrits/inscrits.csv?verified=' + verified + '&optin=' + optin + '&order=' + vm.orderBy, '_blank', '');
            $event.stopPropagation();
            return $event.preventDefault();
          };
        }
      ]
    });
  });

}).call(this);

//# sourceMappingURL=subscribers.js.map
;
